<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card custom-card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title text-uppercase font-weight-bold">Parâmetros de tipo serviço</h4>
              <a class="heading-elements-toggle">
                <i class="ft-more-vertical font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i>
              </a>
              <div class="heading-elements" v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('paramtiposervico.store')">
                      <i class="ft-plus"></i>
                    </a>
                  </li>
                  <li>
                    <a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem">
                      <i class="ft-rotate-cw"></i>
                    </a>
                  </li>
                  <li>
                    <a @click="expandFullscreenFw()" v-b-tooltip title="Expandir" v-if="!isFullscreen">
                      <i class="ft-maximize"></i>
                    </a>
                    <a @click="expandFullscreenFw()" v-b-tooltip title="Minimizar" v-if="isFullscreen">
                      <i class="ft-minimize"></i>
                    </a>
                  </li>
                  <li>
                    <a @click="toggleFilters()" v-b-tooltip title="Filtros">
                      <i class="ft-filter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr style="margin: 0px;">
            <div class="card-content">
              <!-- Filters Section -->
              <div class="card-body pb-0" v-if="showFilters">
                <div class="row align-items-start">
                  <div class="col-md-2">
                    <div class="form-group mb-2">
                      <input type="text" class="form-control custom-input" v-model="filter.cd" placeholder="Código" @keyup.enter="onFilterSet">
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group mb-2">
                      <input type="text" class="form-control custom-input" v-model="filter.descr" placeholder="Descrição" @keyup.enter="onFilterSet">
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group mb-2">
                      <multiselect v-model="filter.status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        placeholder="Status"
                        class="custom-multiselect"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group mb-0">
                      <b-btn class="custom-btn-outline mr-1" variant="outline-secondary" @click="onFilterReset">Limpar</b-btn>
                      <b-btn class="custom-btn-primary" variant="secondary" @click="onFilterSet">Filtrar</b-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive mt-1">
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/paramtiposervico"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="partpema_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="ativo" slot-scope="props">
                      <toggle-button 
                        :value="props.rowData.status.valor == 1"
                        @change="onToggleStatus(props.rowData, $event)"
                        slot="status"
                        :color="{checked: '#13d191', unchecked: '#ccc'}"
                        :sync="true"
                        :width="50"
                        :height="24"
                      />
                    </template>
                    <template slot="actions" slot-scope="props">
                        <a
                          @click="onEdit(props.rowData, props.rowIndex)"
                          v-b-tooltip
                          title="Editar"
                          class="action-icon"
                          v-if="getPermissionFw('paramtiposervico.update')"
                          ><i class="ft-edit-2"></i
                        ></a>
                    </template>
                  </vuetable>
                </div>
              </div>

              <!-- Footer info -->
              <div class="card-footer custom-footer border-top-0 py-1 px-2 d-flex justify-content-between align-items-center">
                <div class="pagination-info text-muted small">
                  {{ paginationInfo }}
                </div>
                <div class="pagination-wrapper">
                  <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                  ></vuetable-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ParamForm
        ref="paramsform"
        :metodo="onFilterReset"
        :tabela="'param_tipo_servico'"
        :rota="'paramtiposervico'"
      >
      </ParamForm>
    </div>
  </div>
</template>

<script>
import Vuetable from '../../components/Vuetable'
import VuetablePagination from '../../components/VuetablePagination'
import VuetablePaginationInfo from '../../components/VuetablePaginationInfo'
import ParamForm from './ParamForm'
import { ToggleButton } from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'

export default {
components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ParamForm,
    ToggleButton,
    Multiselect
},
data () {
    return {
      dataExport: [],
      loadingData: true,
      showFilters: true,
      filter: {
        cd: '',
        descr: '',
        status: null
      },
      optionsLivStatus: [],
      paginationInfo: '',
      fields: [
        {
          name: 'cd',
          title: 'CÓDIGO',
          sortField: 'cd',
          titleClass: 'text-dark font-weight-bold pl-4',
          dataClass: 'col-1'
        },
        {
          name: 'descr',
          title: 'DESCRIÇÃO',
          sortField: 'descr',
          titleClass: 'text-dark font-weight-bold text-left',
          dataClass: 'text-left col-1'
        },
        {
          name: '__slot:ativo',
          title: 'ATIVO',
          sortField: 'status',
          titleClass: 'text-dark font-weight-bold',
          dataClass: 'text-center col-1'
        },
        {
          name: '__slot:actions',
          title: 'AÇÕES',
          titleClass: 'text-dark font-weight-bold text-center',
          dataClass: 'text-center col-1'
        }
    ],
    css: {
        tableClass: 'table table-hover mb-0 custom-table text-center',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          wrapperClass: 'pagination float-right mb-0',
          activeClass: 'active',
          disabledClass: 'disabled',
          pageClass: 'page-item',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
    },
    moreParams: {}
    }
},
mounted() {
    this.getStatus();
},
methods: {
    getStatus() {
      const url = `/api/listitemvalor/jsonlist?tabela=param_tipo_servico&coluna=status`;
      const helpForm = new Form({});
      helpForm.get(url).then(response => {
        this.optionsLivStatus = response.items.map(obj => ({ label: obj.descr, value: obj.valor }));
      }).catch(errors => {
        new ReturnApi(errors, this, true, false, false);
      });
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      
      const from = paginationData.from || 0;
      const to = paginationData.to || 0;
      const total = paginationData.total || 0;
      this.paginationInfo = `Mostrando ${from} a ${to} de ${total} itens (0 itens selecionados)`;
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet () {
        this.loadingData = true;
        this.moreParams = {
            'cd': this.filter.cd,
            'descr': this.filter.descr,
            'status': this.filter.status ? this.filter.status.value : null
        }
        Vue.nextTick(() => { this.$refs.vuetable.refresh(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.filter = { cd: '', descr: '', status: null };
        this.moreParams = {}
        Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
    },
    onCreate () {
      this.$refs.paramsform.onCreate();
    },
    onEdit (data, index) {
      this.id = data.partpserv_id;
      this.$refs.paramsform.onEdit(data, index, this.id);
    },
    onToggleStatus(data, event) {
        const action = event.value ? 1 : 2;
        const helpForm = new Form({statusRecord: [{ partpserv_id: data.partpserv_id, status: action }]});
        this.$refs.paramsform.onActivateDesactivate(helpForm);
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    onCopy() {
      // Placeholder for copy functionality
      this.$snotify.info('Funcionalidade de cópia não implementada');
    },
    onRestore() {
      // Placeholder for restore functionality
      this.$snotify.info('Funcionalidade de restauração não implementada');
    },
    onToggleList() {
      // Placeholder for list toggle
      this.$snotify.info('Alternar visualização de lista');
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
},
computed: {
    isLoaded: {
        get() { return this.$store.getters.isloaded; }
    },
    isFullscreen: {
        get() { return this.$store.getters.is_full_screen; }
    }
}
}
</script>

<style scoped>
.custom-card {
  border-radius: 8px;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  border: none;
}
.card-title {
  font-size: 1rem;
  color: #404E67;
  letter-spacing: 0.5px;
}
.heading-elements .list-inline a {
  padding: 0 8px;
  color: #a3afbb;
  font-size: 1.1rem;
}
.heading-elements .list-inline a:hover {
  color: #404E67;
}

.heading-elements-toggle {
    display: none;
    padding: 0 8px;
}

@media (max-width: 767.98px) {
    .card-header.d-flex {
        display: block !important;
        position: relative;
    }
    .heading-elements-toggle {
        display: block;
        position: absolute;
        top: 18px;
        right: 15px;
        cursor: pointer;
    }
    .heading-elements {
        display: none;
        background: #fff;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        position: absolute;
        top: 55px;
        right: 15px;
        z-index: 1000;
        border-radius: 8px;
        border: 1px solid #f2f2f2;
        padding: 5px 10px;
    }
    .heading-elements.visible {
        display: block;
    }
}

.custom-input {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0.6rem 0.75rem;
  font-size: 0.9rem;
  height: auto;
}
.custom-input::placeholder {
  color: #bfbfbf;
}

.custom-btn-primary {
  border-color: #404e67;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  border-radius: 8px;
}
.custom-btn-outline {
  border-color: #404e67;
  color: #404e67;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  border-radius: 8px;
}
.custom-btn-outline:hover {
  background-color: #404e67;
  color: #fff;
}

.custom-table thead th {
  border-bottom: 2px solid #f2f2f2;
  border-top: none;
  font-size: 0.8rem;
  padding: 1rem;
}
.custom-table tbody td {
  padding: 1.2rem 1rem;
  vertical-align: middle;
  border-top: 1px solid #f2f2f2;
  color: #6b6f82;
}

.action-icon {
  font-size: 1.2rem;
  color: #a3afbb;
}
.action-icon:hover {
  color: #404E67;
}

.custom-footer {
  background-color: #fcfcfc;
  border-top: 1px solid #f2f2f2;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.custom-multiselect >>> .multiselect__tags {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  min-height: 20px;
  line-height: 12px;
}
</style>
